/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	/**
	* Upgrade the new ShowFooter Property - default to false
	**/

	class ShowFooter extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 2006;
		}

		/**
		 * Perform upgrade: default ShowFooter to false
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec){
			if (!spec) {
				return Promise.resolve(spec);
			}

			this._upgradeShowFooter(spec);
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_upgradeShowFooter(spec) {
			if (!spec.properties) {
				spec.properties = {};
			}
			spec.properties['showFooter'] = false;
		}
	}

	return new ShowFooter();
});